import { Message, IMessage } from "./Message";

export interface IAudioMessage extends IMessage {
    Audio:IAudio;
}

export interface IAudio {
    Blob:string;
    MimeType:string;
    Preview:string;
   
}

export const AudioMessage = (props:IAudioMessage) => {




    return <Message {...props}>
        <div className="row">
            <audio controls autoPlay={props.IsInbound ? false:true}>

              <source src={props.Audio.Blob} type={props.Audio.MimeType} />
                    
            </audio>
        </div>
    </Message>

}
